import { c as _c } from "react/compiler-runtime";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import Follower from "./Follower";
export default function FollowersList(t0) {
  const $ = _c(4);
  const {
    followers
  } = t0;
  let t1;
  if ($[0] !== followers) {
    t1 = followers.map(_temp);
    $[0] = followers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-y-4 tw-h-full tw-overflow-hidden">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(follower) {
  return <Follower key={follower.identity.id} follower={follower} />;
}